import{DEFAULT_RPC_TIMEOUT as o}from"../constants.mjs";const t=(t,s)=>t.rpcTimeouts&&t.rpcTimeouts[s]||o;export{t as getRpcTimeout};
